import React, {Component} from 'react'
import {_getTotalQueuedJobs} from "../../../../../../services/apis/WorkerServices"
import formatThousandNumber from "../../../../../../helpers/common/formatThousandNumber"

class IAATotalJobs extends Component {
    state = {
        total: 0
    }

    _refresh = null

    componentDidMount() {
        this._fetchTotal()
        this._refresh = setInterval(() => {
            this._fetchTotal()
        }, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchTotal = async () => {
        const {data, success} = await _getTotalQueuedJobs()

        if (success) {
            this.setState({
                total: data
            })
        }
    }

    render() {
        return (
            <div className="IAATotalJobs">
                <strong>Jobs:</strong>
                <span className="Number"> {formatThousandNumber(this.state.total)} jobs</span>
            </div>
        )
    }
}

export default IAATotalJobs



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/iaa/IAATotalJobs.js